/** 默认配置 */
export const defaultConfig = {
    actionToThemeMap: {},
    defaultTheme: 'basic_functions',
    serverUrl: 'https://data.wegic.ai',
    businessType: '',
    userId: '',
    isAnonymous: true,
    isOnline: false,
    eventPrefix: '',
    enableBatch: true,
    batchSize: 5,
    batchSendInterval: 5000,
    onError: (error, message) => {
        console.error(`[CollectSDK] ${message || error?.toString()}`);
    },
};
export const trackingCountKey = '__collect_tracking_count__';
export const sessionIdKey = '__collect_session_id__';
export const uniqueIdKey = '__collect_unique_id__';
